import { ApolloLink, fromPromise } from '@apollo/client';
import { OperationDefinitionNode } from 'graphql';
import { UserLocationService } from 'services/UserLocationService';

export const userLocationLink = new ApolloLink((operation, forward) => {
  const operationType = (operation.query
    .definitions[0] as OperationDefinitionNode).operation;

  if (operationType !== 'mutation') {
    return forward(operation);
  }

  return fromPromise(UserLocationService.getPosition().catch(() => null))
    .map(pos => {
      if (pos?.latitude != null && pos?.longitude != null) {
        operation.setContext(({ headers = {} }) => ({
          headers: {
            ...headers,
            'latitude-from': String(pos.latitude),
            'longitude-from': String(pos.longitude),
          },
        }));
      }
      return operation;
    })
    .flatMap(() => forward(operation));
});
